export class BaseState {
    constructor({ version: versionIn }) {
        this.version = versionIn === undefined ? this.constructor.VERSION : versionIn;
    }
}
BaseState.VERSION = 0;

//# sourceMappingURL=BaseState.js.map
